interface TotalReferralsProps {
  title: string;
  amount: number;
}

const TotalReferrals: React.FC<TotalReferralsProps> = ({ title, amount }: TotalReferralsProps) => {
  return (
    <div className='flex flex-1 gap-4 items-center justify-between'>
      <p className='text-xl font-medium text-text-primary'>{title}</p>
      <p className='text-2xl font-bold text-blue-100'>{amount}</p>
    </div>
  );
};

export default TotalReferrals;
